const SEMESTERS = [
  {
    display: "Fall 2022",
    key: "f22",
  },
  {
    display: "Spring 2021",
    key: "s21",
  },
  {
    display: "Fall 2020",
    key: "f20",
  },
  {
    display: "Spring 2020",
    key: "s20",
  },
  {
    display: "Fall 2019",
    key: "f19",
  },
]

export default SEMESTERS
